<template lang="pug">
  v-form
    v-text-field(
      box
      label="Budget"
      prepend-icon="euro_symbol"
      v-model="budget"
      title="Budget"
    )
</template>

<script>
export default {
  name: "MapReviewBudget",
  computed: {
    budget: {
      get () {
        return this.$store.state.budget
      },
      set (val) {
        this.$store.dispatch("SET_BUDGET", val)
      }
    }
  }
}</script>
